import Vue from 'vue';

export const NotFound = Vue.component( 'not-found', {
	template: '<h2>404 - Not found</h2>'
});



// WEBPACK FOOTER //
// ./assets/_js/components/404.js